import React, { useRef } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Article } from './types';
import Clamp from 'react-multiline-clamp';
import NewsFeedDoc from '../commons/icons/NewsFeedDoc';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 158px;
  max-height: 158px;
  box-shadow: 1px 1.5px 2px 0px rgb(0 0 0 / 13%);
  -webkit-box-shadow: 1px 1.5px 2px 0px rgb(0 0 0 / 13%);
  -moz-box-shadow: 1px 1.5px 2px 0px rgb(0 0 0 / 13%);
`;

const ArticleContent = styled.div`
  display: flex;
  flex-direction: row;
  height:100%;
  border-bottom: 1px solid #E1E1E1;
`;

const ArticleImage = styled.div`
  width:50%;
  height: 100%;
  max-height: 100%;
  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
  }
`;

const ArticleInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px 10px 10px;
  width:50%;
`;

const ArticleInformationTopSection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 3px;
  .category {
    color: #4FADA6;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: left;
  }
  .title {
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    color: #031C38;
  }
`;

const ArticleInformationBottomSection = styled.div`
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #919191;
  text-transform: uppercase;
`;

const ArticleFooter = styled.div`
  display: flex;
  flex-direction: row;
  padding: 6px 20px;
  justify-content: space-between;
`;

const ReadingStatus = styled.div`
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #071C3E;
  text-transform: uppercase;
`;

const ReadingEstimation = styled.div`
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #919191;
  text-transform: uppercase;
`;

const ArticleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 133px;
`;

interface Props {
  itemData: Article;
}

const ArticleListItem = ({itemData}: Props) => {
  const navigate = useNavigate();
  const titleRef = useRef(null);

  const onClickHandler = (id: number) => {
    navigate(`/newsfeed/read/${id}`);
  };

  const formattedDate = moment(itemData.timestamp).format('MMMM D, YYYY');
  const minutesToRead = Math.floor(itemData.readTime / 60);
  return (
    <Wrapper onClick={() => onClickHandler(itemData.id)}>
      <ArticleWrapper>
        <ArticleContent>
          <ArticleImage>
            {!itemData.media || itemData.media.endsWith('.pdf')
              ? <div style={{ background: '#C5E1DF' }} className="w-100 h-100 d-flex justify-center align-items-center"><NewsFeedDoc /></div>
              : <img src={itemData.media} />
            }
          </ArticleImage>
          <ArticleInformation>
            <ArticleInformationTopSection>
              <span className="category">{itemData.category ? itemData.category.value : 'All'}</span>
              <Clamp withTooltip={true} lines={3}>
                  <span className="title" ref={titleRef}>{itemData.title}</span>
              </Clamp>
            </ArticleInformationTopSection>
            <ArticleInformationBottomSection>
              {formattedDate}  
            </ArticleInformationBottomSection>
          </ArticleInformation>  
        </ArticleContent>
      </ArticleWrapper>
      <ArticleFooter>
        <ReadingStatus>READ ARTICLE</ReadingStatus>
        <ReadingEstimation>{minutesToRead} MIN READ</ReadingEstimation>
      </ArticleFooter>
    </Wrapper>
  );
};

export default ArticleListItem;
